import Api from '@/vuex/api'
import {
  SET_PROPERTY_ACTIONS,
  ADD_PROPERTY_NOTE,
  DELETE_PROPERTY,
  DELETE_PROPERTY_PHOTO,
  EDIT_PROPERTY,
  LOAD_PROPERTY,
  LOAD_PROPERTY_CONTRACTORS,
  LOAD_PROPERTY_NOTES,
  LOAD_PROPERTY_PHOTOS,
  NEW_PROPERTY_CONTRACTOR,
  OPEN_MODAL,
  SELECT_CONTRACTORS,
  UPLOAD_PROPERTY_PHOTO
} from '@/vuex/types'

const api = new Api()
const state = {
  property: {
    uuid: '',
    Notes: [],
    Attachments: [],
    Company: {},
    Contractors: [],
    notesTotal: 0,
    attachmentsTotal: 0,
    contractorsTotal: 0,
    contractorsColumns: []
  },
  propertyActions: [
    { label: 'Edit Property', command: EDIT_PROPERTY, icon: 'fa fa-edit' },
    { label: 'Add Note', command: ADD_PROPERTY_NOTE, icon: 'fa fa-sticky-note' },
    { label: 'Upload Photo', command: UPLOAD_PROPERTY_PHOTO, icon: 'fa fa-upload' },
    { label: 'Select Preferred Contractors', command: SELECT_CONTRACTORS, icon: 'fa fa-wrench' },
    { label: 'Delete Property', command: DELETE_PROPERTY, icon: 'fa fa-trash-alt' }
  ]
}

const getters = {
  propertyActions ({ propertyActions }) {
    return propertyActions
  },
  loadedProperty ({ property }) {
    return property
  },
  propertyNotes ({ property }) {
    return property.Notes
  },
  propertyNotesTotal ({ property }) {
    return property.notesTotal
  },
  propertyPhotos ({ property }) {
    return property.Attachments
  },
  propertyPhotosTotal ({ property }) {
    return property.attachmentsTotal
  },
  propertyContractors ({ property }) {
    return property.Contractors
  },
  propertyContractorsTotal ({ property }) {
    return property.contractorsTotal
  },
  propertyContractorsColumns ({ property }) {
    return property.contractorsColumns
  }
}

const mutations = {
  [SET_PROPERTY_ACTIONS] (state) {
    if (state.propertyActions.find(item => item.label === 'Select Preferred Contractors')) {
      state.propertyActions.splice(3, 1)
    }
  },
  [LOAD_PROPERTY] (state, property) {
    state.property = { ...state.property, ...property }
  },
  [LOAD_PROPERTY_NOTES] (state, notes) {
    state.property.Notes = notes.rows
    state.property.notesTotal = notes.count
  },
  [LOAD_PROPERTY_PHOTOS] (state, photos) {
    state.property.Attachments = photos.rows
    state.property.attachmentsTotal = photos.count
  },
  [LOAD_PROPERTY_CONTRACTORS] (state, contractors) {
    state.property.Contractors = contractors.rows
    state.property.contractorsTotal = contractors.count
    state.property.contractorsColumns = contractors.columns
  }
}

const actions = {
  async [LOAD_PROPERTY] (context, propertyUuid) {
    let property = await api.getProperty(propertyUuid)
    context.commit(LOAD_PROPERTY, property)
  },
  async [EDIT_PROPERTY] (context, property) {
    let editPropertyModal = {
      permalink: 'editProperty',
      options: {
        title: 'Edit Property',
        actionLabel: 'Save'
      },
      params: {
        uuid: property.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editPropertyModal)
  },
  async [DELETE_PROPERTY] (context, property) {
    let deletePropertyModal = {
      permalink: 'deleteProperty',
      options: {
        title: 'Delete Property',
        actionLabel: 'Delete'
      },
      params: {
        uuid: property.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deletePropertyModal)
  },
  async [ADD_PROPERTY_NOTE] (context, property) {
    let addNoteModal = {
      permalink: 'addPropertyNote',
      options: {
        title: 'Add Note',
        actionLabel: 'Save'
      },
      params: {
        uuid: property.uuid
      }
    }
    context.dispatch(OPEN_MODAL, addNoteModal)
  },
  async [UPLOAD_PROPERTY_PHOTO] (context, property) {
    let uploadPropertyPhoto = {
      permalink: 'addPropertyPhoto',
      options: {
        title: 'Upload',
        actionLabel: 'Save'
      },
      params: {
        uuid: property.uuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadPropertyPhoto)
  },
  async [DELETE_PROPERTY_PHOTO] (context, uuid) {
    let deletePropertyPhotoModal = {
      permalink: 'deletePropertyPhoto',
      options: {
        title: 'Confirm Delete',
        actionLabel: 'Delete'
      },
      params: {
        uuid
      }
    }
    context.dispatch(OPEN_MODAL, deletePropertyPhotoModal)
  },
  async [NEW_PROPERTY_CONTRACTOR] (context, payload) {
    let newPropertyContractorModal = {
      permalink: 'newPropertyContractor',
      options: {
        title: 'New Contractor',
        actionLabel: 'Save'
      },
      params: {
        propertyUuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newPropertyContractorModal)
  },
  async [SELECT_CONTRACTORS] (context, payload) {
    let selectContractorModal = {
      permalink: 'selectPropertyContractors',
      options: {
        title: 'Select Contractors',
        actionLabel: 'Save'
      },
      params: {
        propertyUuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, selectContractorModal)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/property.js